module.exports = {
  EMAIL: "EMAIL",
  PASSWORD: "PASSWORD",
  NAME: "NAME",
  GENDER: "GENDER",
  MOBILE: "MOBILE",
  DATE: "DATE",
  IGNORE: "IGNORE",
  NUMBER: "NUMBER",
  DATE_FUTURE: "DATE_FUTURE",
  CLIENT_TYPE: "CLIENT_TYPE",
  BLOOD_TYPE: "BLOOD_TYPE"
};
